import CaseManagementList from "../views/CaseManagementList"
import CaseManagementDetail from "../views/CaseManagementDetail"
import CaseManagementCreate from "../views/CaseManagementCreate"

export default [
	{
		path: "/:tenantId/case-management",
		component: CaseManagementList,
		name: "CaseManagementList",
		meta: { featureId: "caseManagement" },
		props: true
	},
	{
		path: "/:tenantId/case-management/detail/:id",
		component: CaseManagementDetail,
		name: "CaseManagementDetail",
		meta: { featureId: "caseManagement" },
		props: true
	},
	{
		path: "/:tenantId/case-management/create",
		component: CaseManagementCreate,
		name: "CaseManagementCreate",
		meta: { featureId: "caseManagement" },
		props: true
	}
]
